import { ActionType } from '../action-types/index';
import { Action } from '../actions';

const initialState = false;

const reducer = (state: boolean = initialState, action: Action): boolean => {
  switch (action.type) {
    case ActionType.API_TIMEOUT:
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
